<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <navbar />
    <!-- <router-view/> -->
  </div>
</template>

<script>
import navbar from '@/view/navbar'
export default {
  name: 'App',
  components: {
    navbar
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* color: #2c3e50; */
  color:#2c3e50;
  font-size: 14px;
  min-height: calc(100vh - 54px);
  background: #fff;
  box-sizing: border-box;
  width: 100%;
  /* padding-bottom: 54px; */
}
</style>
